export default "__VITE_ASSET__BGpE4igs__"